/**
 * WordPress dependencies
 */
import { Button } from '@safe-wordpress/components';
import { link, linkOff } from '@safe-wordpress/icons';
import { _x } from '@safe-wordpress/i18n';

type LinkedButtonProps = {
	readonly isLinked: boolean;
	readonly onClick: () => void;
};
export default function LinkedButton( {
	isLinked,
	...props
}: LinkedButtonProps ): JSX.Element {
	const label = isLinked
		? _x( 'Unlink radii', 'command', 'nelio-ab-testing' )
		: _x( 'Link radii', 'command', 'nelio-ab-testing' );

	return (
		<Button
			{ ...props }
			className="component-border-radius-control__linked-button"
			size="small"
			icon={ isLinked ? link : linkOff }
			iconSize={ 24 }
			label={ label }
		/>
	);
}
